import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import React from "react";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { Topbar } from './Topbar';
import { Button } from '@mui/material';
//import Payment from './stripe/one_time_paiement/Payment';
import {useState} from 'react';
import {Elements} from '@stripe/react-stripe-js';
import  { Navigate } from 'react-router-dom'
import CheckoutForm from './stripe/one_time_paiement/CheckoutForm';
import { getSentence } from './translations';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';


const StyledCard = styled(Card)(({ theme }) => ({
  minWidth: 256,
  background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)',
  backdropFilter: 'blur(20px)',
  border: '1px solid rgba(255, 255, 255, 0.3)',
  borderRadius: 16,
  boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.4s ease',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-10px) scale(1.02)',
    boxShadow: '0 25px 60px rgba(0, 0, 0, 0.15)',
    borderColor: 'rgba(25, 118, 210, 0.3)',
    '&::before': {
      opacity: 1
    }
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
    opacity: 0,
    transition: 'opacity 0.3s ease'
  }
}));

const CardContentContent = styled(CardContent)({
  padding: "2rem",
  textAlign: "center",
  backgroundColor: "transparent",
  borderRadius: "0 0 16px 16px"
});

const TypographyTitle = styled(Typography)({
  fontFamily: "Montserrat",
  fontSize: "2.5rem",
  color: "#0f172a",
  textAlign: 'center',
  textTransform: "uppercase",
  margin: "1rem 0",
  fontWeight: 800,
  letterSpacing: '-0.02em'
});

const TypographySubtitle = styled(Typography)({
  fontFamily: "Montserrat",
  color: "#64748b",
  marginTop: "1rem",
  textAlign: 'center',
  fontWeight: 500,
  fontSize: "1.5rem",
  marginBottom: "1.5rem",
  lineHeight: 1.6
});

const CustomCard = ({ color, title, subtitle, link, buttonText }) => {
  return (
    <StyledCard>
      <CardActionArea>
        <CardContentContent>
          <TypographyTitle variant="h2">{title}</TypographyTitle>
          <div style={{ 
            borderBottom: "2px solid rgba(0, 0, 0, 0.1)", 
            margin: "1.5rem 0",
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto"
          }} />
          <TypographySubtitle>{subtitle}</TypographySubtitle>
          <Button 
            variant="contained" 
            sx={{
              background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
              width: "100%",
              height: "48px",
              borderRadius: 12,
              color: "white",
              fontWeight: 600,
              fontSize: "1.1rem",
              textTransform: "none",
              boxShadow: '0 8px 25px rgba(99, 102, 241, 0.3)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 12px 35px rgba(99, 102, 241, 0.4)',
                background: 'linear-gradient(135deg, #5b21b6 0%, #7c3aed 100%)'
              }
            }}
          >
            {buttonText}
          </Button>
        </CardContentContent>
      </CardActionArea>
    </StyledCard>
  );
};

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function SellingPage() 
{
  const [value, setValue] = React.useState(0);
  const [ payementPopup, setPayementPopup ] = useState(null);
  const [ stripePromise, setStripePromise ] = useState(null);
  const [ clientSecret, setClientSecret ] = useState('');
  const [ payementForm, setpayementForm ] = useState('');


  async function Payment(paiementType, stripePromise) 
  {
    //const { stripePromise } = props;
    //const paiementType = window.location.pathname.split('/')[2];
    const price = paiementType.split("_")[0] * 2;

    const available_paiement_type = ["10_yearly", "50_yearly", "120_yearly",
                                    "1_hours", "2_hours", "5_hours", "10_hours", "25_hours"]

    if (!available_paiement_type.includes(paiementType))
    {
      return <Navigate to='/SellingPage'  />
    }


    await fetch("/create-payment-intent/" + String(paiementType))
        .then((res) => res.json())
        .then(({clientSecret}) => setClientSecret(clientSecret))
        .then(() => setpayementForm(
            <>
            <p>paiement de : {price} </p>
            {clientSecret && stripePromise && (
              <Elements stripe={stripePromise} options={{ clientSecret, }}>
                <CheckoutForm />
              </Elements>
            )}
          </>
        ));

  }

  function PriceCards(toptext, title1, subtitle1, link1, title2, subtitle2, link2, title3, subtitle3, link3, buyButtonText) {
  return (
    <Box sx={{ 
      width: '100%', 
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0
      }
    }}>
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1, py: 8 }}>
        <Paper 
          elevation={0} 
          sx={{ 
            textAlign: "center", 
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)',
            backdropFilter: 'blur(20px)',
            padding: '3rem',
            marginBottom: '4rem',
            borderRadius: 4,
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)'
          }}
        >
          <Typography 
            variant="h6" 
            sx={{ 
              fontFamily: "Montserrat", 
              color: '#64748b',
              maxWidth: '800px',
              margin: '0 auto',
              lineHeight: 1.7,
              fontSize: '1.25rem',
              fontWeight: 400
            }}
          >
            {toptext}
          </Typography>
        </Paper>
        
        {/*the cards*/}
        <Grid container spacing={4} justifyContent="center" sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
          <Grid item xs={12} md={4}>
            <a href={link1} style={{ textDecoration: 'none' }}>
              <CustomCard 
                color="#bfdbfc" 
                title={title1}
                subtitle={subtitle1}
                buttonText={buyButtonText}
              />
            </a>
          </Grid>

          <Grid item xs={12} md={4}>
            <a href={link2} style={{ textDecoration: 'none' }}>
              <CustomCard 
                color="#bfdbfc" 
                title={title2}
                subtitle={subtitle2}
                buttonText={buyButtonText}
              />
            </a>
          </Grid>

          <Grid item xs={12} md={4}>
            <a href={link3} style={{ textDecoration: 'none' }}>
              <CustomCard 
                color="#bfdbfc" 
                title={title3}
                subtitle={subtitle3}
                buttonText={buyButtonText}
              />
            </a>
          </Grid>
        </Grid>

      </Container>
    </Box>
  );
}

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ height: "100vh", backgroundColor: "#f5f5f5" }}>
      <Topbar />
      <Box sx={{py: { xs: 4, md: 8 }}}>
        <Box>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered indicatorColor="rgba(0,0,0,0)" >
              <Tab label="Abonnement mensuel" sx={{borderRadius: "20px", 
                            backgroundColor: value === 0 ? "rgba(82, 19, 147, 0.6)" : "rgba(82, 19, 147, 0.3)",
                            color: "rgba(0,0,0,0.8)",
                            '&.Mui-selected': {
                              color: '#fff',
                            },
                            fontWeight: "bold"}}/>
              <Tab disabled label="" sx={{borderRadius: "20px", backgroundColor: "rgba(56, 16, 16, 0)", minWidth: "5px"}}/>
              <Tab label="Abonnement annuel" sx={{borderRadius: "20px", 
                            backgroundColor: value === 2 ? "rgba(82, 19, 147, 0.6)" : "rgba(82, 19, 147, 0.3)",
                            color: "rgba(0,0,0,0.8)",
                            '&.Mui-selected': {
                              color: '#fff',
                            },
                            fontWeight: "bold"}}/>
              <Tab disabled label="" sx={{borderRadius: "20px", backgroundColor: "rgba(0, 0, 0, 0)", minWidth: "5px"}}/>
              <Tab label="Achat de crédits" sx={{borderRadius: "20px", 
                            backgroundColor: value === 4 ? "rgba(82, 19, 147, 0.6)" : "rgba(82, 19, 147, 0.3)",
                            color: "rgba(0,0,0,0.8)",
                            '&.Mui-selected': {
                              color: '#fff',
                            },
                            fontWeight: "bold"}}/>
            </Tabs>
          </Box>
          <Box value={value} index={0}  hidden={value !== 0}>
            {PriceCards(getSentence(191) ,"15€", "10h / mois", "/subscribe/10_monthly", "55€", "50h / mois", 
              "/subscribe/50_monthly", "120€", "120h / mois", "/subscribe/120_monthly", getSentence(195))}
          </Box>
          <Box value={value} index={1}  hidden={value !== 2}>
            {//Pay for the whole year at once and get a % reduction.
            }
            {PriceCards(getSentence(192), "160€", "10h / mois", "/paiement/10_yearly", "600€", "50h / mois", 
              "/paiement/50_yearly", "1300€", "120h / mois", "/paiement/120_yearly", getSentence(195))}
          </Box>
          <Box value={value} index={2}  hidden={value !== 4}>
            {PriceCards(getSentence(190), "2€", "1h", "/paiement/1_hours", "15€", "10h", 
              "/paiement/10_hours", "60€", "50h", "/paiement/50_hours", getSentence(67))}
          </Box>
        </Box>
    </div>
  );
}